export const whiteList: string[] = ['totalLine', 'login']